import template from './additional-services.jade';

export default angular
    .module('cian.addForm.additionalServices', [])
    .directive('cianAfAboutObjectAdditionalServices', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
        },
        controllerAs: 'additionalServices',
        template,
    }))
    .name;
